<template>
  <div class="bunjo-info" :id="$alllist[locate].id">
    <h3>{{ $alllist[locate].name }}</h3>
    <div class="bunjo-mainimg">
      <ul class="bunjo-mainimg-tab">
        <li
          v-if="$alllist[locate].droneimg"
          v-on:click="change('drone')"
          v-bind:class="{ active: isActive === 'drone' }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="長方形_36"
                  data-name="長方形 36"
                  width="16"
                  height="16"
                />
              </clipPath>
            </defs>
            <g
              id="グループ_27"
              data-name="グループ 27"
              clip-path="url(#clip-path)"
            >
              <path
                id="パス_54"
                data-name="パス 54"
                d="M84.523,97.773h13.25V84.523H84.523ZM88.745,87.63A1.349,1.349,0,1,1,87.4,88.979a1.348,1.348,0,0,1,1.349-1.349m7.538,6.9a.266.266,0,0,1-.234.14h-9.8a.266.266,0,0,1-.222-.412l1.714-2.612a.665.665,0,0,1,1.054-.075l1.183,1.34,2.143-3.261a.665.665,0,0,1,1.11,0l3.042,4.608a.266.266,0,0,1,.012.273"
                transform="translate(-82.072 -81.903)"
              />
              <path
                id="パス_55"
                data-name="パス 55"
                d="M13.965,0H0V13.965H1.429V1.429H13.965Z"
                transform="translate(-0.169)"
              />
            </g>
          </svg>
          ドローン空撮
        </li>
        <li
          v-on:click="change('map')"
          v-bind:class="{ active: isActive === 'map' }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="10.868"
            height="16"
            viewBox="0 0 10.868 16"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="長方形_98"
                  data-name="長方形 98"
                  width="10.868"
                  height="16"
                />
              </clipPath>
            </defs>
            <g transform="translate(0 0)" clip-path="url(#clip-path)">
              <path
                id="パス_67"
                data-name="パス 67"
                d="M5.434,0A5.434,5.434,0,0,0,0,5.435c0,3.147,2.5,5.115,3.853,7.46C5.147,15.138,5.146,16,5.434,16s.287-.862,1.581-3.105c1.353-2.345,3.853-4.313,3.853-7.46A5.434,5.434,0,0,0,5.434,0m0,7.513A2.079,2.079,0,1,1,7.513,5.435,2.078,2.078,0,0,1,5.434,7.513"
                transform="translate(0 0)"
              />
            </g>
          </svg>
          周辺地図
        </li>
      </ul>
      <div class="droneimg" v-if="isActive === 'drone'">
        <img :src="$alllist[locate].droneimg" />
      </div>
      <div class="map" v-if="isActive === 'map'">
        <iframe
          :src="$alllist[locate].map"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
    <div class="bunjo-img">
      <img :src="$alllist[locate].mainimg" />
    </div>
    <h4>{{ $alllist[locate].subname }}</h4>
    <div
      class="bunjo-section"
      v-for="(list, index) in $alllist[locate].section"
      :key="index"
    >
      <BunjouInfoList :listtarget="list">
        <template v-slot:locatename>
          {{ $alllist[locate].sectionname[index] }}
        </template>
      </BunjouInfoList>
    </div>
  </div>
</template>

<script>
import BunjouInfoList from "@/components/PartsBunjoInfoList.vue";
export default {
  data() {
    return {
      isActive: "map",
    };
  },
  mounted() {
    if (this.$alllist[this.locate].droneimg) {
      this.isActive = "drone";
    }
  },
  components: {
    BunjouInfoList,
  },
  methods: {
    change: function (num) {
      this.isActive = num;
    },
  },
  props: ["locate"],
};
</script>

<style lang="scss" scoped>
.bunjo-info {
  max-width: 960px;
  width: 100%;
  padding: 0 $h-gap;
  margin: 0 auto;
  margin-top: calc($v_gap / 2);
  h3 {
    font-weight: bold;
    font-size: 1.5rem;
    border-bottom: 1px solid $color_sub;
    padding-bottom: 0.25em;
    margin-bottom: 1rem;
  }
  h4 {
    font-weight: bold;
    font-size: 1.5rem;
    padding-bottom: 0.25em;
    margin-bottom: 1rem;
  }
  .bunjo-img {
    margin: 1rem 0;
    outline: 1px solid $color_sub;
  }
  .bunjo-mainimg {
    width: 100%;
    height: 100%;
    position: relative;
    @include tb {
      padding-top: 2.5rem;
    }
    .bunjo-mainimg-tab {
      position: absolute;
      top: 10px;
      right: 10px;
      height: 2.5em;
      z-index: 1;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 2px;
      direction: rtl;
      @include tb {
        width: 100%;
        right: auto;
        left: 0;
        top: 0;
        height: 2.5rem;
      }
      li {
        border-radius: 0.25em;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background-color: $color_lgray;
        height: 100%;
        line-height: 1rem;
        text-align: center;
        cursor: pointer;
        padding: 0 0.5em;
        padding-top: 0.2em;
        font-size: 0.8rem;
        flex-direction: row-reverse;

        @include sp {
          font-size: 0.8rem;
        }
        svg {
          position: relative;
          top: -2px;
          margin-right: 0.5rem;
          fill: $fontcolor;
        }

        &.active {
          background: white;
          color: $color_blue;
          position: relative;
          svg {
            fill: $color_blue;
          }
        }
      }
    }
    .droneimg,
    .map {
      width: 100%;
      height: 0;
      padding-bottom: 50%;
      position: relative;
      overflow: hidden;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
